import FlatButton from '@/components/flat-button';
import ScrollBox from '@/components/scroll-box';
import Text from '@/components/text';
import Tooltip from '@/components/tooltip';
import { IntentClassifierModel } from '@/lib/models/classifier';
import { downloadPhrases } from '@/lib/services/classification.service';
import { Box, Chip, Stack } from '@mui/material';
import { FC } from 'react';
import PhraseButton from './phrase-button';

interface Props {
  classifier: IntentClassifierModel;
}

const PhraseCard: FC<Props> = ({ classifier }) => {
  const { phrases = [] } = classifier;
  const hasPhrases = !!phrases.length;

  const handleExport = () => {
    if (!hasPhrases) {
      return;
    }
    downloadPhrases(classifier);
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between">
        <Text bold>Example Messages</Text>
        <Tooltip
          disabled={!hasPhrases}
          title="Download a list of the current example messages for this intent as a text file"
        >
          <Stack direction="row" gap={1} justifyContent="flex-end">
            <FlatButton
              icon="export"
              label="Download"
              onClick={handleExport}
              color="link"
              size="small"
              disabled={!hasPhrases}
            />
          </Stack>
        </Tooltip>
      </Stack>

      <Box mt={3}>
        <Stack direction="row" justifyContent="space-between" mb={2}>
          <Text size="small">The following messages were used to train this intent.</Text>
          <Chip label={`${phrases.length} messages`} size="small" />
        </Stack>
        <ScrollBox max={5} emptyMessage="No messages have been added yet" key={phrases.length}>
          {phrases.map((phrase, index) => {
            return (
              <Box mb={0.5} key={`${phrase}-${index}`}>
                <PhraseButton phrase={phrase} />
              </Box>
            );
          })}
        </ScrollBox>
      </Box>
    </Box>
  );
};

export default PhraseCard;
